/**
 * [인증 이미지 로드] - Bearer 토큰으로 보호된 이미지를 Blob URL로 변환
 *
 * 썸네일, 아바타 등 인증이 필요한 이미지를 fetch하여
 * Object URL을 반환한다. AbortSignal을 지원하여 컴포넌트
 * 언마운트 시 불필요한 요청을 취소할 수 있다.
 */
import { getAccessToken } from '@/lib/auth';
import { API_BASE } from '@/lib/constants';

export async function fetchAuthImage(
  downloadUrl: string,
  signal?: AbortSignal,
): Promise<string | null> {
  // /api/ 경로가 아니면 인증 이미지가 아니므로 무시
  if (!downloadUrl.startsWith('/api/')) return null;
  try {
    const token = getAccessToken();
    const res = await fetch(`${API_BASE}${downloadUrl}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      credentials: 'include',
      signal,
    });
    if (!res.ok) return null;
    if (signal?.aborted) return null;
    const blob = await res.blob();
    if (signal?.aborted) return null;
    return URL.createObjectURL(blob);
  } catch (err) {
    if (err instanceof DOMException && err.name === 'AbortError') return null;
    return null;
  }
}
